<template>
    <v-container fluid>
        <v-flex xs12 sm12 md12 class="above pa-1 worker-map">
            <worker-map-view ></worker-map-view>
        </v-flex>
    </v-container>
</template>

<script>
    import {mapActions} from 'vuex'
    import WorkerMapView from './WorkerMapView'
    export default {
        name: 'workerMap',
        created() {
            this.getMapTaskLocations()
            this.getNumberAndAddress()
        },
        components: {
            WorkerMapView,
        },
        methods: {
            ...mapActions({
                getMapTaskLocations: 'jobTasks/getWorkerMapTaskLocations',
                getNumberAndAddress: 'jobTasks/getNumberAndAddress',
            }),
        },
    }
</script>

<style scoped>
    .worker-map {
        padding-bottom: 0;
        margin-bottom: 0;
        height: 90vh;
    }
    .custom-row-layout {
        height: 80vh;
        overflow: auto;
        overflow-x: hidden;
    }

    .custom-grid-list {
        margin: unset !important;
    }

    .display-flex {
        display: flex;
    }

    .showMap {
        visibility: hidden;
        position: absolute;
        top: -100px;
    }

    .hideMap {
        visibility: visible;
        position: relative;
        top: 0;
    }
</style>
